import React, { useState, useEffect } from "react";
export default function Table() {
  const [standings, setStandings] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const fetchStandings = async () => {
      try {
        const response = await fetch(
          'https://ndt-dev.katsamsoft.in/api/resource/DPL Standings?fields=["*"]'
        );
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const data = await response.json();

        const sortedData = data.data.sort((a, b) => a.position - b.position);

        setStandings(sortedData);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false);
      }
    };

    fetchStandings();
  }, []);

  return (
    <section className="standingtable">
      <div class="container-fluid">
        <div class="table-responsive">
          <table className="table table-bordered table-hover">
            <thead className="table-dark">
              <tr>
                <th className="text-center">SI NO.</th>
                <th></th>
                <th>TEAMS NAME</th>
                <th>P</th>
                <th>W</th>
                <th>L</th>
                <th className="mobilenone">T</th>
                <th className="mobilenone">+/-</th>
                <th className="mobilenone">PTS</th>
              </tr>
            </thead>
          


            <tbody>
                  {standings.length > 0 ? (
                    standings.map((team, index) => (
                      <tr  key={index}
                      className={team.team === "New Delhi Tigers" ? "highlight" : ""}>
                        <td className="text-center">{index + 1}</td>
                        <td>
                          <img
                            src={`https://ndt-dev.katsamsoft.in/${team.image}`}
                            alt={team.team}
                          />
                        </td>{" "}
                        <td>{team.team}</td>
                        <td>
                        {team.matches ? ` ${team.matches} ` : '-'}

                        </td>
                        <td>
                        {team.won ? ` ${team.won} ` : '-'}
                        </td>
                        <td>
                        {team.lost ? ` ${team.lost} ` : '-'}
                        </td>
                        <td className="mobilenone">
                        {team.tied ? ` ${team.tied} ` : '-'}
                         </td>
                        <td className="mobilenone">  {team.score_diff ? ` ${team.score_diff} ` : '-'}</td>
                        <td className="mobilenone">   {team.points ? ` ${team.points} ` : '-'}</td>
                        
                        {/* Render other data accordingly */}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="3">Loading...</td>
                      <td colSpan="3"></td>
<td className="mobilenone"></td>
<td className="mobilenone"></td>
<td className="mobilenone"></td>
<td className="mobilenone"></td>


                    
                      
                    </tr>
                  )}
                </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}
